import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Cookie } from "@phosphor-icons/react";

export function CookieBanner() {
  const [visible, setVisible] = useState(() => !localStorage.getItem("sb_cookie_consent"));
  if (!visible) return null;
  const decide = (v) => { localStorage.setItem("sb_cookie_consent", v); setVisible(false); };
  return (
    <div data-testid="cookie-banner" className="fixed inset-x-0 bottom-24 z-40 px-3 pointer-events-none">
      <div className="mx-auto max-w-md pointer-events-auto sb-card p-4 border-2 border-gray-800 shadow-xl" style={{ background: "var(--app-surface)" }}>
        <div className="flex items-start gap-2">
          <Cookie size={22} weight="duotone" style={{ color: "var(--app-strong)" }} className="shrink-0 mt-0.5" />
          <p className="font-body text-sm text-gray-700">
            SafeBuddy verwendet nur technisch notwendige Cookies, damit die App funktioniert (z. B. Login, Warenkorb, Spracheinstellung). Es findet kein Tracking und keine Werbung statt.{" "}
            <Link to="/cookies" data-testid="cookie-learn-more" className="underline hover:text-gray-900">Mehr erfahren</Link>
          </p>
        </div>
        <div className="flex gap-2 mt-3">
          <button data-testid="cookie-reject" onClick={() => decide("rejected")} className="sb-btn flex-1 py-2.5 bg-white font-medium text-sm">Ablehnen</button>
          <button data-testid="cookie-accept" onClick={() => decide("accepted")} className="sb-btn flex-1 py-2.5 text-white font-medium text-sm" style={{ background: "var(--app-primary)" }}>Akzeptieren</button>
        </div>
      </div>
    </div>
  );
}
